import { Action } from 'redux'
import { InvoiceActions } from '../../reducers/invoice/actionNames'

const invoiceRejected = (all = false): IInvoiceRejected => ({
  all,
  type: InvoiceActions.Rejected,
})

export interface IInvoiceRejected extends Action<InvoiceActions.Rejected> {
  all?: boolean
}

export default invoiceRejected
